import { CalendarDaysIcon } from '@heroicons/react/24/outline';
import { formatWeekdayDate } from '@odo/shared-ui';

interface AppointmentDateDisplayProps {
    date: string;
}

/** Read-only counterpart of the dashboard Composer's DateField trigger
 *  button — same icon + label, no popover/interaction. */
export function AppointmentDateDisplay({ date }: AppointmentDateDisplayProps) {
    return (
        <div className="w-full flex items-center gap-2 rounded-lg border border-gray-200 bg-white px-3 py-2.5 text-sm text-gray-800">
            <CalendarDaysIcon className="h-4 w-4 text-gray-400 shrink-0" />
            <span className="flex-1 truncate">{formatWeekdayDate(date)}</span>
        </div>
    );
}
